import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { BaseService, ModuleConfigService, ResponseResult } from 'tnx-shared';

@Injectable({
  providedIn: 'root'
})
export class AppUserService extends BaseService {

  entityName = 'AppUser';
  serviceCode = 'sktq';

  constructor(http: HttpClient, injector: Injector,
    private _moduleConfigService: ModuleConfigService) {
    super(http, injector, `${_moduleConfigService.getConfig().environment.apiDomain.userOrgEndpoint}/AppUser`);
  }

  changePassword(item: any): Promise<ResponseResult> {
    const apiUrl = `${this.serviceUri}/ChangePassword`;
    return this._http
      .post<ResponseResult>(apiUrl, item)
      .pipe(catchError(err => this.handleError(err, this._injector)))
      .toPromise();
  }

}
